import { render, staticRenderFns } from "./promotionVoucherTab.vue?vue&type=template&id=23832194&lang=pug"
import script from "./promotionVoucherTab.vue?vue&type=script&lang=js"
export * from "./promotionVoucherTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports